import { Company } from "../model/company";
import { Dict } from "./dict";

export class CompanyRepository {

    constructor() {}

    async list():Promise<Company[]> {
        return fetch('/api/schema/companies').then((response) => { 
            return response.json()
        });
    }

    async byId(id: string):Promise<Company> {
        return fetch(`/api/schema/companies/byid/${id}`).then((response) => { 
            return response.json()
        });
    }

    // async dict():Promise<Dict[]> {
    //     return fetch(`/api/superadmin/companies/dict`).then((response) => { 
    //         return response.json()
    //     });
    // }
}